import { Button } from '../ui/button';
import { DiscordLogo } from './DiscordLogo';

export const DiscordButton = () => {
  return (
    <Button
      size="icon"
      className="bg-[#5865f2]"
      variant="ghost"
      onClick={() => {
        window.native.links?.openExternalURL('https://discord.gg/UdtygQSADC');
      }}
    >
      <DiscordLogo />
    </Button>
  );
};
